<template>
  <el-tooltip
    :placement="position"
    :effect="theme"
  >
    <div slot="content">
      <slot />
    </div>
    <i class="el-icon-question"/>
  </el-tooltip>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'dark',
      validator: value => [
        'dark',
        'light',
      ].indexOf(value) !== -1,
    },
    position: {
      type: String,
      default: 'top',
      validator: value => [
        'top',
        'right',
        'bottom',
        'left',
      ].indexOf(value) !== -1,
    },
  },
}
</script>

<style lang="scss" scoped>
.el-icon-question {
  padding: 2px 5px;
  cursor: help;
  color: #909399;
}
</style>
